import {API_HOST} from "../../config";
import APIPlatformRouter from "./APIPlatformRouter";

class divisionApi {
    /**
     * Get Divisions from Api
     * @param searchFilter
     * @param filter
     * @returns {Promise<{error: string, status: number}|any>}
     */
    async getDivisions(searchFilter = '', filter = {}) {
        let url = new URL(`${API_HOST}${APIPlatformRouter.divisions}/`);
        let params = {
            value: searchFilter.trim().length > 1 ? searchFilter : '',
            ...filter
        };
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        try {
            let response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            });
            if (response.status !== 200) {
                return {
                    'status': response.status,
                    'error': 'Agences introuvables'
                }
            }
            return await response.json();
        } catch (e) {
            console.log(e)
        }
    }

    /**
     * Get one division details, by Id, from Api
     * @returns {Promise<{error: string, status: number}|any>}
     * @param divisionId
     */
    async getDivisionDetailsById(divisionId) {
        let url = new URL(`${API_HOST}${APIPlatformRouter.divisions}/${divisionId}/details`);
        try {
            let response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            });
            if (response.status !== 200) {
                return {
                    'status': response.status,
                    'error': 'Agence introuvable'
                }
            }
            return await response.json();
        } catch (e) {
            console.log(e)
        }
    }
}

export default new divisionApi();